module.exports = __webpack_public_path__ + "img/anodyne.00e148d7.png";